/**
 *  IFunction {
        "code": string,         Mã tính năng
        "name": string,         Tên tính năng
        "value": string,        Giá trị tính năng
        "data_type": number,    Kiểu dữ liệu
        "type": number          Loại dự án áp dụng
    }
    ---
    data_type = 0 -> Kiểu dữ liệu Boolean
    value = "0"   -> FALSE
    value = "1"   -> TRUE
    ---
    data_type = 1 -> Kiểu dữ liệu String
    ---
    data_type = 2 -> Kiểu dữ liệu Integer
    ---
    data_type = 3 -> Kiểu dữ liệu Float
    ---
    data_type = 4 -> Kiểu dữ liệu UTC Timestamp
    ***

    type = 2      -> Áp dụng cho Role
 */

import { FUNCTIONS } from "constants/roles"
import { USER_PROPERTIES } from "constants/user"
import { isArray } from "lodash"
import { getUserProperty } from "utils/helpers"

/**
 * Kiểm tra và trả về giá trị của tính năng trong danh sách tính năng
 * @param {*} functions 
 * @param {*} func 
 * @returns 
 */
export const checkFunctionHaveCode = (functions, func) => {
    const isSystemAdmin = getUserProperty(USER_PROPERTIES.SYSTEM_ADMIN)

    if (!isArray(functions)) {
        return isSystemAdmin ? true : false
    }

    const functionValue = functions.find(f => f?.code === func?.code)

    // Không có function
    if (!functionValue) {
        return isSystemAdmin ? true : false
    }

    // Nếu là STRING → trả value gốc
    if (functionValue?.data_type !== 0) {
        return functionValue?.value
    }

    // BOOLEAN
    if (isSystemAdmin) return true

    return functionValue?.value === "TRUE" || functionValue?.value === "1"
}

export const checkLimitedParticipant = (functions, participantsCount) => {
    try {
        // eslint-disable-next-line max-len
        const meetingParticipantsLimit = checkFunctionHaveCode(functions, FUNCTIONS.MEETING_PARTICIPANTS_LIMIT);

        // eslint-disable-next-line curly
        if (!Number.isInteger(Number(meetingParticipantsLimit))) return true;

        return meetingParticipantsLimit >= participantsCount;
    } catch (error) {
        return true;
    }
};